// @core/api/endpoints/chat/remove_conversation_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Remove member from conversation
 * Removes a member from the conversation, revoking their access to view or send messages. Requires admin privileges on the conversation.
 */
export async function RemoveConversationMember(
  conversation_id: string,
  profile_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/members/:profile_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
